import React, { useState } from "react";
import { DocumentMediaViewerContext } from "./DocumentMediaViewerContext";
import { IDocumentMediaPreviewData } from "@home-health-notify/domain";

type DocumentMediaViewerProviderType = {
  children: React.JSX.Element[];
};

export const DocumentMediaViewerProvider = ({
  children,
}: DocumentMediaViewerProviderType) => {
  const initialDialogState = {
    message: undefined,
    mediaList: [],
    onDocumentMediaDialogClose: undefined,
  };
  const [dialogState, setDialogState] = useState<{
    message?: IDocumentMediaPreviewData;
    mediaList?: IDocumentMediaPreviewData[];
    onDocumentMediaDialogClose?: () => void;
  }>(initialDialogState);

  const openDocumentMediaViewer = (
    message: IDocumentMediaPreviewData,
    mediaList?: IDocumentMediaPreviewData[],
    onDocumentMediaDialogClose?: () => void,
  ) => {
    setDialogState({
      message,
      mediaList,
      onDocumentMediaDialogClose,
    });
  };

  const onDocumentMediaDialogClose = () => {
    dialogState.onDocumentMediaDialogClose &&
      dialogState.onDocumentMediaDialogClose();
    setDialogState(initialDialogState);
  };

  return (
    <DocumentMediaViewerContext.Provider
      value={{
        openDocumentMediaViewer,
        message: dialogState.message,
        mediaList: dialogState.mediaList,
        onDocumentMediaDialogClose,
      }}
    >
      {children}
    </DocumentMediaViewerContext.Provider>
  );
};
